import script from "./PageView.vue?vue&type=script&setup=true&lang=js"
export * from "./PageView.vue?vue&type=script&setup=true&lang=js"

import "./PageView.vue?vue&type=style&index=0&id=0674f97c&lang=css"

const __exports__ = script;

export default __exports__